<template>
  <div>
    <LessonHeader :hide-display="'hide_content'" />
    <div class="browser-container">
      <div class="content">
        <el-row class="description">
          <div class="row-center">
            <div v-html="getMessage"></div>
          </div>
          <div class="mt20 countdown-message" v-html="getErrorNote"></div>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { myStageApiBaseUrl, errorCodes } from '@/utils/constants';
import { getHomeUrl } from '@/utils/urlHelper';
import LessonHeader from '@/components/Lesson/Header/LessonHeader';
import axios from 'axios';
import qs from 'qs';

export default {
  components: {
    LessonHeader
  },
  created() {
    axios.post(
      myStageApiBaseUrl + `/lesson/log`,
      qs.stringify({ payload: JSON.stringify({
          msg: `Error page loaded with error code: ${this.$route.query.code} for lesson id: ${this.unverifiedLessonId}`
        })
      })
    );
  },
  beforeMount: function() {
    if (this.unverifiedPayload) {
      this.$i18n.locale = this.unverifiedPayload.a === 's' ? 'ja' : 'en';
    } else {
      this.$i18n.locale = 'ja';
    }
  },
  computed: {
    ...mapState(['unverifiedPayload', 'unverifiedLessonId']),
    ...mapState('userOtherSetting', ['countryId']),
    getMessage() {
      const code = this.$route.query.code;
      const safeCode = Object.values(errorCodes).includes(code) ? code : errorCodes.ME002;
      return this.$t(`errors.${safeCode}.message`);
    },
    getErrorNote() {
      return this.$t('errors.general.message', [this.homeUrl]);
    },
    homeUrl() {
      return getHomeUrl(this.countryId);
    }
  }
};
</script>

<style scoped>
.countdown-message {
  line-height: 18px;
}
.browser-container {
  margin-top: 20px;
  padding: 0 20px 20px 20px;
}
.description {
  font-size: 15px;
  line-height: 25px;
  text-align: center;
}
.countdown-message >>> a,
.countdown-message >>> a:visited {
  color: #1287cd !important;
}
.mt20 {
  margin-top: 20px;
}
.mt40 {
  margin-top: 40px;
}
</style>
